module.exports = __webpack_public_path__ + "static/media/dosa.3899968c.jpg";